<div class="flex justify-center">
    <h2 class="font-light leading-relaxed text-2xl py-8 text-gray-800 cursor-default">Actions done in {{city}}</h2>
</div>
<div class="w-1/2 px-8 py-4 mx-auto">
    <div class="shadow">
        <div class="border-b">
            <div class="border-l-2 border-transparent">
                <ng-container *ngFor="let data of data; index as i;">
                    <div class="flex justify-center text-xl p-2 font-light cursor-pointer text-gray-100"
                        [class.cia]="data.Action_Cat === 'CIA-FOOD CONSUMER'"
                        [class.dia]="data.Action_Cat === 'DIA-FOOD DISTRIBUTION'"
                        [class.gia]="data.Action_Cat === 'GIA-FOOD GOVERNANCE'"
                        [class.pia]="data.Action_Cat === 'PIA-FOOD PRODUCTION AND PROCESSING'"
                        [class.wia]="data.Action_Cat === 'WIA-FOOD WASTE'" (click)="onClick($event.target.value)"
                        value="{{data.Action_Cat}}">
                        {{data.Action_Cat}} &nbsp;
                        <i *ngIf="!data.expanded" class="fas fa-chevron-down text-md pointer-events-none"></i>
                        <i *ngIf="data.expanded" class="fas fa-chevron-up text-md pointer-events-none"></i>
                    </div>
                    <div *ngIf="data.expanded">
                        <div *ngFor="let action of actions[i]">
                            <div class="shadow">
                                <div class="border-b">
                                    <div class="border-l-2 border-transparent">
                                        <div class="p-1 text-lg font-thin hover:bg-yellow-200 cursor-pointer"
                                            (mouseover)="onActionMouseover(action)" mat-raised-button
                                            matTooltip={{description}} matTooltipClass="tooltip">
                                            {{action}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>